import { Component, OnInit } from '@angular/core';
import {environment} from "../../../environments/environment";
import {AuthenicationService} from "../../_services/authenication.service";
import {ActivatedRoute, Router} from "@angular/router";
import {ContactusService} from "../../_services/contactus.service";
import {ToasterService} from "../../_services/toaster.service";
import {ExcelServicesService} from "../../_services/excel-services.service";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
import { CompanyEnquiryService, CompanyEnquiry } from '../../../app/_services/companyEnquiry.service';
declare var $: any;

@Component({
  selector: 'app-company-enquiry-list-v2',
  templateUrl: './company-enquiry-list-v2.component.html',
  styleUrls: ['./company-enquiry-list-v2.component.css']
})
export class CompanyEnquiryListv2Component implements OnInit {

  userdetaild: string;
  baseUrl: string = environment.baseUrl;
  returnUrl: string;
  enquiries: CompanyEnquiry[];

  constructor(private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute, private contactusservice: ContactusService, private toaster: ToasterService,private excelService:ExcelServicesService,private spinnerService: Ng4LoadingSpinnerService, private companyEnquiryService: CompanyEnquiryService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }
    // if (!this.userdetaild || this.userdetaild['users_usertype'] !== 'admin') {
    //   this.authenicationService.logout();
    //   this.router.navigateByUrl('/login');
    // }
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

    this.getAllOrganisationEnquiry();
  }
  exportAsXLSX():void {
    this.spinnerService.show();
    this.excelService.exportAsExcelFile(this.enquiries, 'customers_school_enquiry_users');
    this.spinnerService.hide();
  }

  getAllOrganisationEnquiry() {
    this.companyEnquiryService.fetchAll().subscribe(
      (data: any) => {
        if(data && data.length > 0) {
          this.enquiries = data;
          setTimeout(() => {
            $(function() {
              $('#example').DataTable();
            });
          }, 1000);
        } else {
          this.toaster.showError('Users', data.ResponseMessage);
            setTimeout( () => {
              $(function() {
                $('#example').DataTable();
              });
            }, 1000);
        }
      },
      error => {
        this.toaster.showError('Users', error.error.ResponseMessage);
          setTimeout( () => {
            $(function() {
              $('#example').DataTable();
            });
          }, 1000);
      }
    )
  }

}
